/**
 * Bridge to the Yeastarify desktop tray app (desktop/), whose windows load this site. Outside the
 * app every call here is a no-op.
 */

type TauriInternals = { invoke: (command: string, args?: Record<string, unknown>) => Promise<unknown> };

function internals(): TauriInternals | null {
  return ((window as unknown as { __TAURI_INTERNALS__?: TauriInternals }).__TAURI_INTERNALS__ ?? null);
}

export function isDesktopApp() {
  return internals() !== null;
}

/** The small always-on-top pop-up window of the desktop app (path /desktop-popup). */
export function isDesktopPopupWindow() {
  return isDesktopApp() && window.location.pathname === '/desktop-popup';
}

export async function desktopInvoke(command: string, args?: Record<string, unknown>) {
  const tauri = internals();
  if (!tauri) return null;
  try {
    return await tauri.invoke(command, args);
  } catch (error) {
    console.warn(`Desktop app command ${command} failed:`, error);
    return null;
  }
}
